import type { Guide, GuideRecordHint } from '../types';

/** S-21.10-06 — ostrzeżenie o wariantach floty przy publikacji (scenariusz e2e 17, ścieżka TRD-05). */
const TRADE_ORDER: GuideRecordHint = {
  description: 'zlecenie w Trade, przy którym planiści FTL mają warianty pojazdów',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'TRADE' },
};

export const guide: Guide = {
  flagKey: 'publicationFleetVariantsWarning',
  title: 'Ostrzeżenie o wariantach floty przy publikacji',
  whatItDoes:
    'Gdy zlecenie w Trade ma warianty floty, sekcja publikacji, okno „Wystaw na TIMOCOM / Trans.eu” i kolejka publikacji pokazują „Zlecenie ma warianty floty: pojazd (autor wariantu)” — żeby przed publikacją skonsultować się z FTL. To ostrzeżenie, nie blokada: publikacja przechodzi, a wynik i historia zlecenia zapisują, że ostrzeżenie było widoczne i kto opublikował mimo niego.',
  audience: ['Trade'],
  presentationItems: ['S-21.10-06'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'fleet-variants-warning',
      mockupTestId: 'trd-zlecenie-konsultacja-ftl',
      title: 'Ostrzeżenie w sekcji publikacji',
      description:
        'Przy zleceniu: które pojazdy są wariantami i kto je dodał. Odsyłacz prowadzi do wariantów na karcie zlecenia.',
      action: 'Przed publikacją skontaktuj się z planistą, który dodał wariant.',
      recorder: { account: 'trade', demo: { kind: 'order', number: 'DEMO/2026/10/P04' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'publish-dialog-fleet-variants',
      mockupTestId: 'trd-publikacja-publikuj',
      title: 'To samo w oknie publikacji',
      description:
        'Okno „Wystaw na TIMOCOM” powtarza ostrzeżenie. „Wystaw” zostaje aktywne — decyzja należy do tradera, a zapis mówi, że opublikował mimo ostrzeżenia.',
      action: 'Kliknij „Wystaw na TIMOCOM”, potwierdź warunki i zdecyduj, czy wystawić.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/P04' },
        actions: [{ kind: 'clickButton', name: 'Wystaw na TIMOCOM' }],
      },
    },
  ],
};
